import { parseCountryIds } from './countryUtils';

export const DEFAULT_MANAGER_FILTERS = {
  search: '',
  status: '',
  fromCountry: '',
  toCountry: '',
  dateFrom: '',
  dateTo: '',
};

const uniqueSorted = (values, countries = []) => {
  const seen = new Set();
  const options = [];

  values.forEach((id) => {
    const normalized = String(id).trim();
    if (!normalized || seen.has(normalized)) return;
    seen.add(normalized);
    const country = countries.find((item) => String(item.id) === normalized);
    options.push({
      id: normalized,
      name: country?.name?.trim() || normalized,
    });
  });

  return options.sort((a, b) => a.name.localeCompare(b.name));
};

export const getManagerFilterOptions = (managers, countries = []) => {
  const fromCountries = [];
  const toCountries = [];

  managers.forEach((manager) => {
    fromCountries.push(...parseCountryIds(manager.from_country));
    toCountries.push(...parseCountryIds(manager.to_country));
  });

  return {
    fromCountries: uniqueSorted(fromCountries, countries),
    toCountries: uniqueSorted(toCountries, countries),
  };
};

export const getCountryFilterOptions = (countries = [], managers = []) => {
  const managerOptions = getManagerFilterOptions(managers, countries);
  const allIds = uniqueSorted(
    [
      ...managerOptions.fromCountries.map((item) => item.id),
      ...managerOptions.toCountries.map((item) => item.id),
      ...countries.map((country) => String(country.id)),
    ],
    countries
  );

  return {
    fromCountries: allIds,
    toCountries: allIds,
  };
};

export const hasActiveManagerFilters = (filters) =>
  Object.values(filters).some((value) => value !== '' && value != null);

const matchesCountryFilter = (managerCountries, filterCountryId) => {
  if (!filterCountryId) return true;
  const list = parseCountryIds(managerCountries);
  return list.some((id) => String(id) === String(filterCountryId));
};

export const filterManagers = (managers, filters) =>
  managers.filter((manager) => {
    if (filters.search) {
      const query = filters.search.toLowerCase().trim();
      const name = String(manager.name || '').toLowerCase();
      const email = String(manager.email || '').toLowerCase();
      if (!name.includes(query) && !email.includes(query)) {
        return false;
      }
    }

    if (filters.status && manager.status !== filters.status) {
      return false;
    }

    if (!matchesCountryFilter(manager.from_country, filters.fromCountry)) {
      return false;
    }

    if (!matchesCountryFilter(manager.to_country, filters.toCountry)) {
      return false;
    }

    if (filters.dateFrom && manager.created_at) {
      const created = new Date(manager.created_at);
      const from = new Date(filters.dateFrom);
      if (created < from) return false;
    }

    if (filters.dateTo && manager.created_at) {
      const created = new Date(manager.created_at);
      const to = new Date(filters.dateTo);
      to.setHours(23, 59, 59, 999);
      if (created > to) return false;
    }

    return true;
  });
